/**
 * Check if element is focusable
 */
export const isElementFocusable = (element: HTMLElement): boolean => {
  return !element.hasAttribute('disabled') && element.tabIndex > -1;
};
